import { createRouter, createWebHistory } from "vue-router";
import Home from "@/pages/HomePage.vue";
import Services from "@/pages/ServicesPage.vue";
import Team from "@/pages/TeamPage.vue";
import GovContractPage from "./pages/GovContractPage.vue";

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/services',
    name: 'Services',
    component: Services,
  },
  {
    path: '/team',
    name: 'Team',
    component: Team,
  },
  {
    path: '/government-contracting',
    name: 'GovContracting',
    component: GovContractPage
  }
]

export const router = createRouter({
  history: createWebHistory(),
  routes
})